export enum VizAliasType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export enum VizAliasStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export interface Consent {
  version: string;
  presenter: string;
  validFromDateTime: string; // ISO 8601 format
}

export interface ContactInfo {
  type: VizAliasType;
  value: string;
}

export interface Profile {
  lastName: string;
  firstName: string;
  contactInfo: ContactInfo[];
}

export interface Identification {
  type: "CPF" | string; // e.g., Brazilian tax ID
  value: string;
}

export interface VizAliasInfo {
  returnCode: number;
  institutionCode: string;
  requestId: string;
  dateTime: string;
  status: VizAliasStatus;
  aliasType: VizAliasType;
  createdOn: string;
  aliasValue: string;
  lastModifiedOn: string;
  consent: Consent;
  profile: Profile;
  identification: Identification;
}

export enum VizCardPreferredForType {
  SEND = 'SEND',
  PAY = 'PAY',
  RECEIVE = 'RECEIVE'
}

export interface VizCard {
  lastFour: string;
  paymentCredentialId: string;
  nameOnCard: string;
  preferredFor: VizCardPreferredForType[];
  status: string;
  isPreferred?: boolean;
  maskedCardNumber?: string;
  currencyCode: string;
}

export interface VizCardEntity {
  dateTime: string;
  returnCode: number;
  lastFourList: VizCard[];
  institutionCode: string;
  requestId: string;
}

export interface VizPayee {
  country: {
    code: string;
    name: string;
    dialingCode: number;
    validDigitCount: number;
    ordinal: number;
    excluded: boolean;
  };
  payeeId: number;
  recipientAliasType: VizAliasType;
  recipientAliasValue: string;
  nickname: string;
}